<template>
	<div>
		<CRow>
  		<CCol sm="4" lg="2">
        <CWidgetSimple header="Revenue" text="1,123">
          <CChartBarSimple style="height:40px" background-color="success"/>
        </CWidgetSimple>
      </CCol>
			<CCol sm="4" lg="2">
        <CWidgetSimple header="Orders" text="112">
          <CChartBar
    				style="height:40px"
    				:datasets="[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#E55353',
        				label: 'Orders',
      				}
    				]"
    				labels="months"
    				:options="{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}"
  				/>
        </CWidgetSimple>
      </CCol>
			<CCol sm="4" lg="2">
        <CWidgetSimple header="Product" text="2121">
          <CChartBar
    				style="height:40px"
    				:datasets="[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#2982cc',
        				label: 'Product',
      				}
    				]"
    				labels="months"
    				:options="{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}"
  				/>
        </CWidgetSimple>
      </CCol>
			 <CCol sm="4" lg="2">
        <CWidgetSimple header="Customer" text="70">
          <CChartBar
    				style="height:40px"
    				:datasets="[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#1b9e3e',
        				label: 'Orders',
      				}
    				]"
    				labels="months"
    				:options="{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}"
  				/>
        </CWidgetSimple>
      </CCol>
			<CCol sm="4" lg="2">
        <CWidgetSimple header="Cart Item" text="70">
          <CChartBar
    				style="height:40px"
    				:datasets="[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#f6960b',
        				label: 'Cart',
      				}
    				]"
    				labels="months"
    				:options="{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}"
  				/>
        </CWidgetSimple>
			</CCol>
			<CCol sm="4" lg="2">
        <CWidgetSimple header="Post Reach" text="70">
          <CChartBar
    				style="height:40px"
    				:datasets="[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#1f1498',
        				label: 'Cart',
      				}
    				]"
    				labels="months"
    				:options="{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}"
  				/>
        </CWidgetSimple>
			</CCol>
    </CRow>
		<CCard>
      <CCardBody>
        <CRow>
          <CCol sm="5">
            <h4 id="traffic" class="card-title mb-0">Traffic</h4>
            <div class="small text-muted">November 2017</div>
          </CCol>
          <CCol sm="7" class="d-none d-md-block">
            <CButton color="primary" class="float-right">
              <CIcon name="cil-cloud-download"/>
            </CButton>
            <CButtonGroup class="float-right mr-3">
              <CButton
                color="outline-secondary"
                v-for="(value, key) in ['Day', 'Month', 'Year']"
                :key="key"
                class="mx-0"
                :pressed="value === selected ? true : false"
                @click="selected = value"
              >
                {{value}}
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
        <MainChartExample style="height:300px;margin-top:40px;"/>
      </CCardBody>
      <!-- <CCardFooter>
        <CRow class="text-center">
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Visits</div>
            <strong>29.703 Users (40%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="success"
              :value="40"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Unique</div>
            <strong>24.093 Users (20%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="info"
              :value="20"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">Pageviews</div>
            <strong>78.706 Views (60%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="warning"
              :value="60"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0">
            <div class="text-muted">New Users</div>
            <strong>22.123 Users (80%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              color="danger"
              :value="80"
            />
          </CCol>
          <CCol md sm="12" class="mb-sm-2 mb-0 d-md-down-none">
            <div class="text-muted">Bounce Rate</div>
            <strong>Average Rate (40.15%)</strong>
            <CProgress
              class="progress-xs mt-2"
              :precision="1"
              :value="40"
            />
          </CCol>
        </CRow>
      </CCardFooter> -->
    </CCard>
  </div>
</template>

<script>
import { CChartLineSimple, CChartBarSimple } from './charts/index.js'
import { CChartBar,CChartLine } from '@coreui/vue-chartjs'
import MainChartExample from './charts/MainChartExample'
export default {
	name: 'Dashboard1',
	components: {
		CChartBarSimple,
		CChartBar,
		CChartLine,
		MainChartExample
	},
	data () {
    return {
			selected: 'Month',
		}
	},
	computed: {
    defaultDatasets () {
      return [
        {
          label: 'Data One',
          backgroundColor: 'rgb(228,102,81,0.9)',
          data: [30, 39, 10, 50, 30, 70, 35]
        },
        {
          label: 'Data Two',
          backgroundColor: 'rgb(0,216,255,0.9)',
          data: [39, 80, 40, 35, 40, 20, 45]
				},
				{
          label: 'Data Three',
          backgroundColor: 'rgb(0,216,255,0.9)',
          data: [20, 20, 20, 20, 20, 20, 20]
        }
      ]
    }
  }

}
</script>

<style>

</style>

